module.exports = __webpack_public_path__ + "img/tsc_img.920723dd.png";